class StoreManager {
  static state;
  static action;
  static dispatch;

  static toggleEmailHint(flag) {
    StoreManager.dispatch({ type: StoreManager.action.toggleEmailHint, payload: flag });
  }

  static togglePasswordHint(flag) {
    StoreManager.dispatch({ type: StoreManager.action.togglePasswordHint, payload: flag });
  }

  static checkFieldIsValid(field) {
    return StoreManager.state[field].isDirty && !StoreManager.state[field].isValid;
  }

  static changeEmail(value) {
    StoreManager.dispatch({ type: StoreManager.action.changeEmail, payload: value });
  }

  static changePassword(value) {
    StoreManager.dispatch({ type: StoreManager.action.changePassword, payload: value });
  }

  static toggleEye() {
    StoreManager.dispatch({ type: StoreManager.action.toggleEye });
  }

  static clickStayLogginedIn() {
    StoreManager.dispatch({ type: StoreManager.action.clickStayLoggedIn });
  }
}

export default StoreManager;